<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>{{ vendor.id ? 'Edit ' : 'Create ' }} Vendor</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form #form="ngForm" (ngSubmit)="onSubmit(form, !vendor.id)">

  <hr class="m-0 p-0">

  <mat-dialog-content class="px-3 py-4">

    <div class="row">
      <div class="col-12 col-lg-8">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Name</mat-label>
          <input
            matInput
            placeholder="Name"
            [(ngModel)]="vendor.name"
            name="name"
            type="text"
            required
            #name />
          <mat-hint>Please enter a vendor name.</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-12 col-lg-4">
        <app-phone-input
          [idInput]="mobile_input_id"
          [numberInput]="vendor.phone"
          [countryCodeInput]="vendor.phone_country_code"
          [dialCodeInput]="vendor.phone_dial_code"
          [e164NumberInput]="vendor.phone_e164"
          [additionalClassInput]="'compact'"
          (phoneDetailsOutput)="getOutputPhoneDetails($event)"
          [labelInput]="'Phone Number'"
          [hintInput]="'Enter vendor phone number here.'"
          required="true">
        </app-phone-input>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-lg-4">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Email</mat-label>
          <input
            matInput
            [pattern]="emailPattern"
            placeholder="example@company.com"
            [(ngModel)]="vendor.email"
            required
            name="email"
            type="email"
            #email="ngModel" />
          <mat-hint>Please enter a vendor email.</mat-hint>
          <mat-error *ngIf="email.invalid && (email.touched || form.submitted)">
            Please enter a valid email address.
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-12 col-lg-4">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Website</mat-label>
          <input
            matInput
            placeholder="https://company.com"
            [(ngModel)]="vendor.website"
            (ngModelChange)="onWebsiteChange($event, website)"
            name="website"
            type="url"
            #website="ngModel" />
          <mat-hint>Please enter a vendor website. Include https:// at the beginning.</mat-hint>
          <mat-error *ngIf="website.errors?.['invalidWebsite'] && (website.touched || form.submitted)">
            Please enter a valid website URL. Include https:// at the beginning.
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-12 col-lg-4">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Insurance Expiry Date</mat-label>
          <input
            matInput
            (dateInput)="onInsuranceExpiryDateChange($event.value)"
            [matDatepicker]="insuranceExpiryPicker"
            placeholder="Insurance Expiry Date"
            [(ngModel)]="vendor.insurance_valid_till"
            name="insurance_valid_till"
            readonly
            (click)="insuranceExpiryPicker.open()"/>
          <mat-datepicker-toggle matSuffix [for]="insuranceExpiryPicker"> </mat-datepicker-toggle>
          <button type="button" matSuffix mat-icon-button *ngIf="vendor.insurance_valid_till" (click)="vendor.insurance_valid_till = null" matTooltip="Remove the vendor insurance expiry date."><mat-icon>close</mat-icon></button>
          <mat-datepicker #insuranceExpiryPicker></mat-datepicker>
          <mat-hint>Select the vendor insurance expiry date.</mat-hint>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-lg-4">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>When was the Insurance Verified?</mat-label>
          <input
            matInput
            [matDatepicker]="verifiedPicker"
            [max]="today"
            placeholder="Insurance Verified Date"
            [(ngModel)]="insuranceLastVerifiedDate"
            name="insurance_last_verified_date"
            readonly
            (click)="verifiedPicker.open()"/>
          <mat-datepicker-toggle matSuffix [for]="verifiedPicker"> </mat-datepicker-toggle>
          <button type="button" matSuffix mat-icon-button *ngIf="insuranceLastVerifiedDate" (click)="insuranceLastVerifiedDate = null" matTooltip="Clear the vendor insurance verified date."><mat-icon>close</mat-icon></button>
          <mat-datepicker #verifiedPicker></mat-datepicker>
          <mat-hint>Select the vendor insurance verified date.</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-12 col-lg-4">
        <div class="full-width mb-4">
          <mat-slide-toggle [(ngModel)]="vendor.is_prequalified" name="is_prequalified">
            Pre-Qualified?
          </mat-slide-toggle>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic" *ngIf="vendor.is_prequalified">
          <mat-label>Pre-Qualified Date</mat-label>
          <input
            matInput
            (dateInput)="onPreQualifiedDateChange($event.value)"
            [matDatepicker]="preQualifiedPicker"
            [max]="today"
            placeholder="Pre-Qualified Date"
            [(ngModel)]="vendor.prequalified_date"
            name="prequalified_date"
            readonly
            (click)="preQualifiedPicker.open()"/>
          <mat-datepicker-toggle matSuffix [for]="preQualifiedPicker"> </mat-datepicker-toggle>
          <button type="button" matSuffix mat-icon-button *ngIf="vendor.prequalified_date" (click)="vendor.prequalified_date = null" matTooltip="Remove the vendor pre-qualified date."><mat-icon>close</mat-icon></button>
          <mat-datepicker #preQualifiedPicker></mat-datepicker>
          <mat-hint>Select the vendor pre-qualified date.</mat-hint>
        </mat-form-field>
      </div>
    </div>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Notes</mat-label>
      <textarea
        rows="4"
        matInput
        placeholder="Notes"
        [(ngModel)]="vendor.notes"
        name="notes">
      </textarea>
      <mat-hint>Please enter any notes for the vendor.</mat-hint>
    </mat-form-field>

    <app-address-lookup
      label="Address Lookup"
      placeholder="Search for an address"
      hint="Search for an address to auto-fill the address fields below."
      (addressSelected)="onAddressSelected($event)">
    </app-address-lookup>

    <mat-form-field class="full-width mt-4 mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Address</mat-label>
      <input
        matInput
        placeholder="Address"
        [(ngModel)]="vendor.address"
        name="address"
        type="text"
        id="address"/>
      <mat-hint>Enter the address of the vendor.</mat-hint>
    </mat-form-field>

    <div class="row">
      <div class="col-md-6">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ utils.getLangTerm('accounts.form.suburb', 'Suburb') }}</mat-label>
          <input
            matInput
            [placeholder]="utils.getLangTerm('accounts.form.suburb', 'Suburb')"
            [(ngModel)]="vendor.suburb"
            name="suburb"
            type="text"
            id="suburb"/>
          <mat-hint>Enter the {{ utils.getLangTerm('accounts.form.suburb', 'Suburb').toLowerCase() }} of the vendor.</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ utils.getLangTerm('accounts.form.city', 'City') }}</mat-label>
          <input
            matInput
            [placeholder]="utils.getLangTerm('accounts.form.city', 'City')"
            [(ngModel)]="vendor.city"
            name="city"
            type="text"
            id="city"/>
          <mat-hint>Enter the {{ utils.getLangTerm('accounts.form.city', 'City').toLowerCase() }} of the vendor.</mat-hint>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ utils.getLangTerm('accounts.form.postal_code', 'Postal Code') }}</mat-label>
          <input
            matInput
            [placeholder]="utils.getLangTerm('accounts.form.postal_code', 'Postal Code')"
            [(ngModel)]="vendor.postal_code"
            name="postal_code"
            type="text"
            id="postal_code"/>
          <mat-hint>Enter the {{ utils.getLangTerm('accounts.form.postal_code', 'Postal Code').toLowerCase() }} of the vendor.</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field class="full-width mb-0" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Country</mat-label>
          <input
            matInput
            placeholder="Country"
            [(ngModel)]="vendor.country"
            name="country"
            type="text"
            id="country"/>
          <mat-hint>Enter the country of the vendor.</mat-hint>
        </mat-form-field>
      </div>
    </div>

  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="p-3">

    <button
      mat-raised-button
      [disabled]="!form.valid || inProgress"
      color="primary"
      type="submit"
      class="my-2 ml-1 mr-2"
      id="save">
      <mat-icon>save</mat-icon>
      Save
    </button>

    <button
      mat-raised-button
      class="my-2 ml-1 mr-2"
      type="button"
      color="secondary"
      (click)="onSelectInsuranceVerifier()"
      [matBadge]="'' + (vendor.insurance_last_verified_by ? 1 : 0)"
      matTooltip="You can optionally select an insurance verifier.">
      <mat-icon>rate_review</mat-icon>
      {{ !vendor.insurance_last_verified_by ? 'Select' : 'Change' }} Insurance Verifier
    </button>

    <app-file-browse-button
      (selectedFiles)="onSelectFiles($event)"
      (afterDialogClosedEvent)="onSubmit(form, false)"
      parentObjectType="vendor"
      [parentObjectId]="vendor.id"
      [filesCount]="vendor?.files?.length">
    </app-file-browse-button>

    <button
      type="button"
      color="warn"
      class="dialog-remove-button my-2 ml-auto mr-1"
      mat-icon-button
      [disabled]="!vendor.id"
      (click)="onDelete()"
      [matTooltip]="'Archive this Vendor'">
      <mat-icon>archive</mat-icon>
    </button>

  </mat-dialog-actions>

</form>
